module.exports = __webpack_public_path__ + "assets/img/Flag-of-Pakistan.d8b6fc9b.jpg";